import create from 'zustand';
import chatApi from 'lib/api/chat';
import alertMessage from 'global/AlertMessage';
import router from 'next/router';
import groupChatAnalytics from 'features/chat/analytics/GroupChatAnalytics';

interface IGroupInvitationStore {
  data: any;
  isLoading: boolean;
  fetchPreview: (code: string) => void;
  joinGroup: (code: string) => void;
}

const groupInvitationStore = create<IGroupInvitationStore>((set) => ({
  data: null,
  isLoading: false,
  fetchPreview: (code) => {
    set({ isLoading: true });
    chatApi
      .getGroupInvitationPreview(code)
      .then((res) => {
        const { data } = res.data;
        set({ data, isLoading: false });
        // group chat tracker
        groupChatAnalytics.groupChatInfoSettings.onGroupChatLinkFromOtherPlatformOpened();
      })
      .catch((err) => {
        if (err.response.data) {
          alertMessage({
            content: err.response.data.message,
            messageType: 'error',
            alertType: 'plain',
          });
        }
        // group chat tracker
        groupChatAnalytics.groupChatInfoSettings.onGroupChatLinkNotFoundViewed();
        set({ isLoading: false });
      });
  },
  joinGroup: (code) => {
    chatApi
      .postJoinGroup(code)
      .then((res) => {
        const { data } = res.data;

        if (data) {
          const { id } = data.room;
          // group chat tracker
          groupChatAnalytics.groupInfoSettingsAction.onGroupChatJoinGroupInvitationLinkOpened();

          // redirect to group chat room detail
          router.push(`/group-chat/${id}`);
        }
      })
      .catch(() => {});
  },
}));

export default groupInvitationStore;
